import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { AgedReceivablesWrapper } from "../../components";

export default function AgedReceivablesPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <AgedReceivablesWrapper organization={organization} />
    </ModalProvider>
  );
}
